import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=0d061934&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=ts"
export * from "./DataExport.vue?vue&type=script&lang=ts"
import style0 from "./DataExport.vue?vue&type=style&index=0&id=0d061934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d061934",
  null
  
)

export default component.exports